<app-breadcrumb [title]="'Contratista'" [items]="['PESV', 'Diagnostico']"
  [active_item]="'Contratista'"></app-breadcrumb>

<div class="container-fluid">
  <div class="card">
    <div class="card-header d-flex align-items-center bg-primary text-white">
      <i class="icofont icofont-building-alt me-2"></i>
      <h5 class="mb-0"><strong>CONTRATISTAS PESV (PROVEEDORES)</strong></h5>
    </div>

    <div class="card-body">
      <div class="row mb-3">
        <div class="col-sm-12 col-md-4 ms-auto">
          <div class="input-group">
            <input type="text" class="form-control" placeholder="Buscar por NIT, nombre, servicios o correo..."
              [(ngModel)]="filtro" (input)="aplicarFiltro()" />
            <span class="input-group-text">
              <i class="fa fa-search"></i>
            </span>
          </div>
        </div>
      </div>

      <div *ngIf="cargando" class="text-center py-4">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Cargando...</span>
        </div>
      </div>

      <div *ngIf="!cargando" class="table-responsive tabla-con-scroll">
        <table class="table table-hover table-bordered align-middle mb-0" id="tblContratistaPesv">
          <thead class="bg-primary">
            <tr>
              <th class="text-center"><strong>N°</strong></th>
              <th class="text-center" style="cursor: pointer" (click)="sortData('nombre')">
                <strong>NOMBRE DEL CONTRATISTA O PROVEEDOR</strong>
                <i class="fa" [ngClass]="{
                  'fa-sort-up': sortColumn === 'nombre' && sortDirection === 'asc',
                  'fa-sort-down': sortColumn === 'nombre' && sortDirection === 'desc',
                  'fa-sort': sortColumn !== 'nombre'
                }"></i>
              </th>
              <th class="text-center"><strong>NIT</strong></th>
              <th class="text-center"><strong>TIPO DE CONTRATISTA</strong></th>
              <th class="text-center col-servicios"><strong>SERVICIOS</strong></th>
              <th class="text-center"><strong>CANTIDAD DE CONDUCTORES</strong></th>
              <th class="text-center"><strong>CANTIDAD DE VEHICULOS</strong></th>
              <th class="text-center"><strong>TIPO DE VEHICULOS</strong></th>
              <th class="text-center"><strong>TIPO DE VEHICULOS2</strong></th>
              <th class="text-center"><strong>ACCION</strong></th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="let proveedor of proveedoresFiltrados | paginate: { itemsPerPage: pageSize, currentPage: page }; let i = index">
              <td class="text-center">{{ ((page - 1) * pageSize) + i + 1 }}</td>
              <td class="text-uppercase">{{ proveedor.nombre || '-' }}</td>
              <td class="text-center">{{ proveedor.nit || '-' }}</td>
              <td class="text-center">
                <select class="form-select form-select-sm" [ngModel]="proveedor.tipo_contratista"
                  (ngModelChange)="actualizarSelect(proveedor, 'tipo_contratista', $event)">
                  <option *ngFor="let opcion of opcionesTipoContratista" [ngValue]="opcion.value">{{ opcion.label }}</option>
                </select>
              </td>
              <td class="text-center col-servicios">
                <input type="text" class="form-control form-control-sm" [ngModel]="proveedor.servicios"
                  (ngModelChange)="actualizarTexto(proveedor, 'servicios', $event)" maxlength="250" placeholder="Ingrese servicios" />
              </td>
              <td class="text-center">
                <input type="number" class="form-control form-control-sm" [ngModel]="proveedor.cantidad_conductores"
                  (ngModelChange)="actualizarNumero(proveedor, 'cantidad_conductores', $event)" min="0" placeholder="Cantidad de conductores" />
              </td>
              <td class="text-center">
                <input type="number" class="form-control form-control-sm" [ngModel]="proveedor.cantidad_vehiculos"
                  (ngModelChange)="actualizarNumero(proveedor, 'cantidad_vehiculos', $event)" min="0" placeholder="Cantidad de vehiculos" />
              </td>
              <td class="text-center">
                <select class="form-select form-select-sm" [ngModel]="proveedor.tipo_vehiculos"
                  (ngModelChange)="actualizarSelect(proveedor, 'tipo_vehiculos', $event)">
                  <option *ngFor="let opcion of opcionesVehiculoFrecuente" [ngValue]="opcion.value">{{ opcion.label }}</option>
                </select>
              </td>
              <td class="text-center">
                <select class="form-select form-select-sm" [ngModel]="proveedor.tipo_vehiculos2"
                  (ngModelChange)="actualizarSelect(proveedor, 'tipo_vehiculos2', $event)">
                  <option *ngFor="let opcion of opcionesVehiculoFrecuente" [ngValue]="opcion.value">{{ opcion.label }}</option>
                </select>
              </td>

              <td class="text-center accion-fila">
                <button type="button" class="btn btn-sm btn-primary"
                  [disabled]="proveedor.guardando" (click)="guardarFilaContratista(proveedor)">
                  {{ proveedor.guardando ? '...' : 'Guardar' }}
                </button>
              </td>
            </tr>
            <tr *ngIf="!proveedoresFiltrados.length">
              <td colspan="11" class="text-center py-3">No se encontraron proveedores.</td>
            </tr>
          </tbody>
        </table>

        <div class="d-flex justify-content-between align-items-center mt-4">
          <div class="d-flex align-items-center">
            <label for="pageSizeContratista" class="me-2">Mostrar:</label>
            <select id="pageSizeContratista" class="form-select w-auto" [(ngModel)]="pageSize" (change)="page = 1">
              <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
            </select>
            <span class="ms-2">registros por pagina</span>
          </div>

          <div class="text-center flex-grow-1">
            Total Registros:
            <a class="badge badge-primary"><b>{{ proveedoresFiltrados?.length || 0 }}</b></a>
          </div>

          <div class="text-end paginador-personalizado">
            <pagination-controls (pageChange)="page = $event" [maxSize]="5" [directionLinks]="true" [autoHide]="true"
              previousLabel="Anterior" nextLabel="Siguiente">
            </pagination-controls>
          </div>
        </div>

        <div class="mt-4">
          <div class="btn-showcase text-center">
            <button class="btn btn-outline-success-2x" type="button" placement="top" ngbTooltip="Exportar a Excel"
              (click)="exportarExcel('tblContratistaPesv','listado_contratistas_pesv')">
              <i class="icofont icofont-file-excel"></i> EXCEL
            </button>

            <button class="btn btn-outline-danger-2x" type="button" placement="top" ngbTooltip="Exportar a PDF"
              (click)="exportToPDF('tblContratistaPesv','listado_contratistas_pesv','Listado Contratistas PESV')">
              <i class="icofont icofont-file-pdf"></i> PDF
            </button>
          </div>
        </div>

        <div class="d-flex justify-content-center align-items-center gap-2 mt-3">
          <button class="btn btn-primary" type="button" (click)="guardarTodo()" [disabled]="guardandoTodo">
            {{ guardandoTodo ? 'Guardando...' : 'Guardar todo' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
